import React, { useCallback } from 'react'
import { SearchField as ExtSearchField } from '@sencha/ext-modern'
import { doScan } from '../../Form/Block/renderLiveScan'
import { useInstData } from 'tyan/public/hooks'
const preventCtrlR = (e, el) => (/* console.log('CtrlR'),  */e.preventDefault())

const SearchField = props => {
	const { me } = useInstData(props)
	const { scannable } = props
	const handleScanned = useCallback(data => {
		// console.log('data:', data, me.searchField)
		me.searchField && me.searchField.setValue(data)
	}, [])
	const scanHandler = useCallback(() => doScan({ onScanned: handleScanned }), [])

	return <ExtSearchField shadow align="right" ui="solo ks-search-right-trigger" width="280"
		ref={ref => ref && (me.searchField = ref.cmp)}
		placeholder={'搜索...'}
		margin="0 10 0 0"
		keyMap={{ 'Ctrl+R': { handler: preventCtrlR } }}
		triggers={scannable ? {
			scan: {
				iconCls: 'x-fa fa-qrcode',
				// ui: 'action',
				side: 'right',
				handler: scanHandler
			}
		} : undefined}
		{...props}
	/>
}

export default SearchField